module.exports = __webpack_public_path__ + "static/img/sangwenfeng.ebe48fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/sangwenfeng.png
// module id = Kzzy
// module chunks = 0